export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6629.8c85ec71.jpg";